exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".procedure-check[data-v-4760598c] {\n  padding-left: 1.5em;\n  cursor: pointer;\n}", ""]);

// exports
